/**
 * Simple, non-technical copy for toast notifications.
 */

export const TOAST_SUCCESS = "Your changes have been saved.";

export const TOAST_ERROR = "Oops, something went wrong.";

export const TOAST_DISCONNECTED = "Attempting to reconnect.";

export const TOAST_RECONNECTED = "You're back online.";

/** Shown while sparx editor save is in progress (promise toast). */
export const TOAST_SAVING = "Saving…";

/** Stable id for the reconnecting toast so we can dismiss it when a good response arrives. */
export const RECONNECTING_TOAST_ID = "reconnecting";

/** Stable ids so we can dismiss by type and keep only one toast visible. */
export const ERROR_TOAST_ID = "error";
export const RECONNECTED_TOAST_ID = "reconnected";

/** Warning when editor route names a sparx file not present in the catalog. */
export const UNKNOWN_SPARX_EDITOR_TOAST_ID = "unknown-sparx-editor";

/** Catalog list or off-route blueprint load failed; sidebar editor entry blocked until full page refresh. */
export const SPARXS_EDITOR_UNAVAILABLE_TOAST_ID = "sparxs-editor-unavailable";

export const SPARXS_EDITOR_UNAVAILABLE_TOAST =
  "Sparxs Editor could not be loaded. Refresh the page to try again.";

/** Teaser sidecar fetch failed (non-404) while the editor is already showing data. */
export const SPARX_TEASER_LOAD_FAILED_TOAST_ID = "sparx-teaser-load-failed";

export const SPARX_TEASER_LOAD_FAILED_TOAST =
  "Teaser could not be loaded. Try again or refresh the page.";

/** Shown when the reactions message catalog fails to load for a sparx with the reactions addon. */
export const REACTION_MESSAGES_UNAVAILABLE_TOAST =
  "Reaction messages could not be loaded.";

/** Root shell logout action failed (network or server error). */
export const SHELL_ACTION_FAILED_LOGOUT_TOAST =
  "Sign out failed. Try again or refresh the page.";

/** Root shell financial-institution switch failed. */
export const SHELL_ACTION_FAILED_SWITCH_FI_TOAST =
  "Could not switch organization. Try again.";
